import React from 'react';
import { useTranslation } from 'react-i18next';



class SMSChatErrorBoundary extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }


  componentDidCatch(error, errorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
    console.error("SMSChat Error Boundary Caught Error:", error, errorInfo);
  }

  
  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-light text-danger">
          <h4>{t ? t('text.chat.somethingWentWrongInSMSChat') : 'Something went wrong in SMSChat'}</h4>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default SMSChatErrorBoundary;
